import { MessageTemplate } from "@/pb/scout/message_template/v1/message_template_pb";
import { TemplateRow } from "./MessageTemplateList/MessageTemplateRow/types";

// protoファイルから生成されたクラスを画面表示で扱うinterfaceに変換
export const toMessageTemplate = (item: MessageTemplate) => {
  return {
    id: item.getId(),
    title: item.getName(),
    message: item.getBody()
  } as TemplateRow;
};

export const autoCloseToast = (closeToastFunc: () => void) => {
  setTimeout(() => {
    closeToastFunc();
    // 以下の実装を参考に自動でトーストが閉じる時間を設定した。
    // c.f. https://github.com/OneCareerJP/cloud/blob/3bb5d4cb94ec61ad7a36e6fca7df032a44086d49/frontend/src/components/Pages/Entries/index.vue#L859
  }, 10000);
};
